import FpLogo from "@/assets/fp-logo.svg";
import { useRouter } from "@tanstack/react-router";
import { User } from "lucide-react";
import type { FpMessage } from "../../../schemas/codegen";

export function Avatar({ sender }: { sender: FpMessage["sender"] }) {
  if (sender === "user") {
    return <UserAvatar />;
  }

  const containerClass =
    "grid place-content-center w-full aspect-square rounded-md bg-primary overflow-hidden";

  return (
    <div className={containerClass}>
      <FpLogo className="w-full h-full text-default" />
    </div>
  );
}

function UserAvatar() {
  const router = useRouter();
  const { user } = router.options.context.auth;

  const containerClass =
    "flex items-center justify-center w-full aspect-square rounded-md bg-primary/10 overflow-hidden";

  return (
    <div className={containerClass}>
      {user?.avatarUrl ? (
        <img
          src={user.avatarUrl}
          alt="User avatar"
          className="w-full h-full object-cover rounded-md"
        />
      ) : (
        <User className="w-full h-full" />
      )}
    </div>
  );
}
